/* =====================================================================
   Auracql PureFlow — product page behavior
   Vanilla JS, no dependencies. Handles: gallery, variant matching,
   price updates, quantity, add-to-cart (AJAX), sticky bar, scroll reveal.
   ===================================================================== */
(function () {
  'use strict';

  /* ---------- Scroll reveal (guaranteed visible) ---------- */
  function initReveal() {
    var els = document.querySelectorAll('.pf [data-pf-section]');
    els.forEach(function (el) { el.classList.add('pf-reveal'); });
    var reveal = function (el) { el.classList.add('is-in'); };
    var inFold = function (el) { return el.getBoundingClientRect().top < window.innerHeight * 0.92; };
    els.forEach(function (el) { if (inFold(el)) reveal(el); });
    if (!('IntersectionObserver' in window)) { els.forEach(reveal); return; }
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (e) { if (e.isIntersecting) { reveal(e.target); io.unobserve(e.target); } });
    }, { rootMargin: '0px 0px -8% 0px' });
    els.forEach(function (el) { if (!el.classList.contains('is-in')) io.observe(el); });
    // Safety net: never leave a section hidden.
    setTimeout(function () { els.forEach(reveal); }, 2500);
  }

  /* ---------- Gallery ---------- */
  function initGallery() {
    var thumbs = document.querySelectorAll('[data-pf-thumb]');
    var main = document.getElementById('pf-main-media');
    if (!thumbs.length || !main) return;
    thumbs.forEach(function (btn) {
      btn.addEventListener('click', function () {
        var img = btn.querySelector('img');
        if (img && main.tagName === 'IMG') {
          main.src = img.src.replace(/width=200/, 'width=1100');
          main.srcset = '';
        }
        thumbs.forEach(function (t) { t.classList.remove('is-active'); });
        btn.classList.add('is-active');
      });
    });
  }

  /* ---------- Variant selection ---------- */
  function initVariants() {
    var form = document.getElementById('pf-product-form');
    var dataEl = document.querySelector('[data-pf-variants]');
    if (!form || !dataEl) return;
    var variants;
    try { variants = JSON.parse(dataEl.textContent); } catch (e) { return; }

    var idInput = form.querySelector('[data-pf-variant-id]');
    var priceEl = form.querySelector('[data-pf-price]');
    var compareEl = form.querySelector('[data-pf-compare]');
    var saveEl = form.querySelector('[data-pf-save]');
    var availEl = form.querySelector('[data-pf-availability]');
    var atc = form.querySelector('[data-pf-atc]');
    var atcText = form.querySelector('[data-pf-atc-text]');
    var stickyPrice = document.querySelector('[data-pf-sticky-price]');
    var stickyCompare = document.querySelector('[data-pf-sticky-compare]');
    var stickyAtc = document.querySelector('[data-pf-sticky-atc]');

    function money(cents) {
      return '€' + (cents / 100).toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 });
    }

    function selectedOptions() {
      var opts = [];
      form.querySelectorAll('[data-pf-option]').forEach(function (input) {
        if (input.checked) opts[parseInt(input.dataset.pfOption, 10)] = input.value;
      });
      return opts;
    }

    function findVariant(opts) {
      return variants.find(function (v) {
        return v.options.every(function (o, i) { return o === opts[i]; });
      });
    }

    function update() {
      var opts = selectedOptions();
      if (!opts.length) return;
      var v = findVariant(opts);
      if (!v) return;
      if (idInput) idInput.value = v.id;
      if (priceEl) priceEl.textContent = money(v.price);
      if (stickyPrice) stickyPrice.textContent = money(v.price);
      if (compareEl) {
        if (v.compare_at_price && v.compare_at_price > v.price) {
          compareEl.style.display = '';
          compareEl.textContent = money(v.compare_at_price);
          if (saveEl) {
            var saved = v.compare_at_price - v.price;
            var pct = Math.round((saved * 100) / v.compare_at_price);
            saveEl.style.display = '';
            saveEl.textContent = 'Save ' + money(saved) + ' · ' + pct + '%';
          }
          if (stickyCompare) { stickyCompare.style.display = ''; stickyCompare.textContent = money(v.compare_at_price); }
        } else {
          compareEl.style.display = 'none';
          if (saveEl) saveEl.style.display = 'none';
          if (stickyCompare) stickyCompare.style.display = 'none';
        }
      }
      var available = v.available;
      [atc, stickyAtc].forEach(function (b) { if (b) b.disabled = !available; });
      if (atcText) atcText.textContent = available ? 'Add to cart' : 'Sold out';
      if (stickyAtc) stickyAtc.textContent = available ? 'Add to cart' : 'Sold out';
      if (availEl) availEl.textContent = available ? 'In stock — ready to ship' : 'Currently sold out';
    }

    form.querySelectorAll('[data-pf-option]').forEach(function (input) {
      input.addEventListener('change', update);
    });
    update();
  }

  /* ---------- Quantity ---------- */
  function initQty() {
    var wrap = document.querySelector('[data-pf-qty]');
    if (!wrap) return;
    var input = wrap.querySelector('[data-pf-qty-input]');
    wrap.querySelector('[data-pf-qty-minus]').addEventListener('click', function () {
      input.value = Math.max(1, (parseInt(input.value, 10) || 1) - 1);
    });
    wrap.querySelector('[data-pf-qty-plus]').addEventListener('click', function () {
      input.value = Math.min(99, (parseInt(input.value, 10) || 1) + 1);
    });
  }

  /* ---------- Add to cart (AJAX, drawer-compatible) ---------- */
  function initAddToCart() {
    var form = document.getElementById('pf-product-form');
    if (!form) return;
    form.addEventListener('submit', function (e) {
      // If the theme has no JS cart, let the native POST proceed.
      if (!window.fetch) return;
      e.preventDefault();
      var atc = form.querySelector('[data-pf-atc]');
      var atcText = form.querySelector('[data-pf-atc-text]');
      var original = atcText ? atcText.textContent : '';
      if (atc) atc.disabled = true;
      if (atcText) atcText.textContent = 'Adding…';

      var formData = new FormData(form);
      fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Accept': 'application/json' },
        body: formData
      })
        .then(function (r) { return r.json(); })
        .then(function () {
          if (atc) { atc.classList.add('is-added'); atc.disabled = false; }
          if (atcText) atcText.textContent = 'Added to cart ✓';
          // Notify the theme's cart drawer / bubble to refresh.
          document.dispatchEvent(new CustomEvent('pf:cart:added'));
          ['cart:refresh', 'cart:build'].forEach(function (name) {
            document.dispatchEvent(new CustomEvent(name, { bubbles: true }));
          });
          if (window.Shopify && window.Shopify.onCartUpdate) {
            fetch('/cart.js').then(function (r) { return r.json(); }).then(function (c) { window.Shopify.onCartUpdate(c); });
          }
          setTimeout(function () {
            if (atc) atc.classList.remove('is-added');
            if (atcText) atcText.textContent = original || 'Add to cart';
          }, 2000);
        })
        .catch(function () {
          if (atc) atc.disabled = false;
          if (atcText) atcText.textContent = original || 'Add to cart';
          form.submit(); // fall back to native add
        });
    });
  }

  /* ---------- Sticky mobile bar ---------- */
  function initSticky() {
    var bar = document.querySelector('[data-pf-sticky]');
    var hero = document.querySelector('.pf-hero');
    if (!bar || !hero) return;
    function onScroll() {
      var past = (hero.getBoundingClientRect().bottom) < 0;
      bar.classList.toggle('is-visible', past);
      bar.setAttribute('aria-hidden', past ? 'false' : 'true');
    }
    window.addEventListener('scroll', onScroll, { passive: true });
    onScroll();
  }

  function init() {
    initReveal();
    initGallery();
    initVariants();
    initQty();
    initAddToCart();
    initSticky();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
  // Re-init in the theme editor when sections reload.
  document.addEventListener('shopify:section:load', init);
})();
